import React, { useEffect, useState } from "react";
import styles from "../../../src/styles/Blog/BlogsCategories.module.css";
import { getCategories } from "../../ReuableFunctions/Categories";

const Categories = () => {
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await getCategories();
        if (data.length > 0) {
          setCategories(data);
        }
      } catch (err) {
        console.error("Error fetching blogs: ", err);
      }
    };
    fetchCategories();
  }, []);
  return (
    <div className={styles.categoriesContainer}>
      <div className={styles.categoriesTitle}>Categories</div>

      <div className={styles.categoryParentContainer}>
        {categories.length === 0 && <div>No Category Available</div>}
        {categories.length > 0 &&
          categories.map((category, index) => (
            <React.Fragment key={index}>
              <div className={styles.categoryContainer}>
                <div>{category?.blogCategory}</div>
                <div>{category?.count}</div>
              </div>
              {index !== categories.length - 1 && (
                <div className={styles.categoryBorder}></div>
              )}
            </React.Fragment>
          ))}
        {/* <div className={styles.categoryContainer}>
          <div>Artificial Intelligence</div>
          <div>19</div>
        </div>
        <div className={styles.categoryBorder}></div> */}
      </div>
    </div>
  );
};

export default Categories;
